import ReactDOM from 'react-dom';
import React from 'react';
import Bluebird from 'bluebird';
import { AppContainer } from 'react-hot-loader';
import { datadogRum } from '@datadog/browser-rum';
import App from './containers/Main';

window.Promise = Bluebird;

function fetchConfig() {
  return new Promise((resolve, reject) => {
    let config = {};
    fetch('/spaces/datadog-api.json')
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          config = data;
        }
        resolve(config);
      })
      .catch((e) => {
        //eslint-disable-next-line no-console
        console.log('Failed fetching data from datadog-api.json', e);
        reject(e);
      });
  });
}

function fetchJSP() {
  return new Promise((resolve, reject) => {
    let config = {};

    fetch('/kobi.jsp')
      .then((response) => response.text())
      .then((html) => {
        const version = html.match(/Version:\s*([^\s<]+)/)[1];
        const env = html.match(/VIP:\s*([^\s<]+)/)[1];

        config = { version, env };
        resolve(config);
      })
      .catch((e) => {
        //eslint-disable-next-line no-console
        console.log('Failed fetching data from kobi.jsp');
        reject(e);
      });
  });
}

async function initializeDataDog() {
  const config = await fetchConfig();
  const jspConfig = await fetchJSP();

  if (!config || !jspConfig) return

  datadogRum.init({
    applicationId: config.SSP_APPLICATION_TOKEN,
    clientToken: config.DATADOG_API_KEY,
    site: 'datadoghq.com',
    service: 'SSP',
    env: jspConfig.env,
    version: jspConfig.version,
    sessionSampleRate: 20,
    sessionReplaySampleRate: 2,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [(url) => url.includes('.jsp'), (url) => url.includes('api/v1')]
  });
}

initializeDataDog();

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root')
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./containers/Main', () => {
    render(App);
  });
}

//jenkinstest



// WEBPACK FOOTER //
// ./index.js